import { COUPON_OFFERS, REWARD_OFFERING } from "../../constants";
import OnboardingPage from "../../common/components/OnboardingPage";
import { RetrieveCoupon } from "../../common/utils/RetrieveCoupon";

function TotalToolsMain() {
  const { loading, coupon } = RetrieveCoupon(COUPON_OFFERS.totaltools);
  const redeemUrl = GLOBAL_CFG["total-tools"].redeem.redeemUrl;

  return (
    <>
      {!loading && (
        <OnboardingPage
          partnerCfg={GLOBAL_CFG["total-tools"]}
          redeemUrl={redeemUrl}
          coupon={coupon}
          rewardId={REWARD_OFFERING.totaltools}
        />
      )}
    </>
  );
}

export default TotalToolsMain;
